import { SyntheticEvent, ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useGetIsUserPermittedTo } from '@occc/utils-access-control';

import { NavigationSubItem } from './types';
import { SidebarProductItem } from './SidebarProductItem';
import { SidebarSubItem } from './SidebarSubItem';
import { getIsActive } from './utils';

type NestedNavProps = {
  items: NavigationSubItem[];
  title: string;
  icon: ReactNode;
  baseUrl?: string;
};

export const NestedNav = ({ title, icon, items, baseUrl }: NestedNavProps) => {
  const { pathname } = useLocation();
  const filter = useGetIsUserPermittedTo();

  const links = items.filter((item) => {
    if (item.accessControlKey == null) return false;

    return Array.isArray(item.accessControlKey)
      ? item.accessControlKey.some((feature) => filter(feature))
      : filter(item.accessControlKey);
  });

  const isActive =
    (baseUrl ? pathname.startsWith(baseUrl) : false) ||
    !!links.find((item) => getIsActive(item, pathname));
  const [isExpanded, setExpanded] = useState(isActive);

  const handleChange = (_: SyntheticEvent, value: boolean) => setExpanded(value);

  useEffect(() => {
    setExpanded(isActive);
  }, [isActive]);

  return (
    <SidebarProductItem
      onChange={handleChange}
      isExpanded={isExpanded}
      title={title}
      icon={icon}
      isActive={isActive}
      content={links.map((link) => (
        <SidebarSubItem
          key={`${link.location}-${link.title}`}
          isActive={getIsActive(link, pathname)}
          title={link.title}
          linkTo={link.location}
        />
      ))}
      hasContent={!!links.length}
    />
  );
};
